<script setup lang="ts">
const props = defineProps<{
  data: any
  payType: number
  isSmall?: boolean
  disabled?: boolean
  text?: string
  label?: string
}>()
const emit = defineEmits(['click'])
const btnClass = computed(() => {
  switch (props.data.key) {
    case 'trial':
      return 'vip-btn__trial'
    case 'standard':
      return 'vip-btn__standard'
    case 'enterprise':
      return 'vip-btn__enterprise'
    default:
      return 'vip-btn__trial'
  }
})
const { userRole, isSubAccount } = useLogin()
const user = useUser()
const isTrial = computed(() => user.value?.info?.isTrial) // 是否是赠送3天体验的企业会员
const { locale } = useI18n()
const isEnPage = computed(() => locale.value === 'en')
const userType = computed(() => isTrial.value ? 3 : (user.value?.info?.userRole || 3))
function getBtnText(type: number) {
  if (props.disabled) {
    return '已加入企业团队'
  }
  if (userType.value === 3) {
    return type === userType.value ? '立即体验' : '立即购买'
  }
  if (userType.value === 2) {
    return type === userType.value ? '会员续费' : type < userType.value ? '立即购买' : `已开通${userRole.value?.resourceName}会员`
  }
  if (userType.value === 1) {
    return type === userType.value ? isSubAccount.value ? '已加入企业团队' : '会员续费' : `已开通${userRole.value?.resourceName}会员`
  }
  return '立即购买'
}
const isDisabled = computed(() => {
  if (isTrial.value)
    return false
  if (props.data?.resource > userType?.value || isSubAccount.value)
    return true
  return false
})
function handleClick() {
  if (props.disabled || isDisabled.value)
    return
  emit('click')
}
</script>

<template>
  <span
    class="vip-btn max-w-300"
    :class="[btnClass, { disabled: isDisabled }, {
      'min-w-110': isEnPage,
      'min-w-132': !isEnPage,
    }]"
    @click="handleClick"
  >
    {{ text || label || $t(`vip.${getBtnText(data.resource)}`) }}
  </span>
</template>

<style lang="less" scoped>
.vip {
  &-btn  {
    display: inline-block;
    padding: 8px 16px;
    border-radius: 8px;
    font-weight: 500;
    font-size: 16px;
    cursor: pointer;
    line-height: 24px;
    text-align: center;
    box-sizing: border-box;
  }
  &-btn__enterprise {
    background: linear-gradient(91deg, #3F4555 4.2%, #16121D 98.67%);
    box-shadow: 0px 16px 36px 0px rgba(45, 52, 67, 0.14);
    color: #E9CDAE;
    &:hover {
      background: linear-gradient(91deg, rgba(63, 69, 85, 0.80) 4.2%, rgba(22, 18, 29, 0.80) 98.67%);
    }
    &.disabled {
      background: #C5C4C6;
      cursor: not-allowed;
    }
  }
  &-btn__trial {
    background: linear-gradient(91deg, #4295FF 4.21%, #0765F1 84.5%);
    box-shadow: 0px 16px 36px 0px rgba(36, 137, 245, 0.09);
    color: #fff;

    &:hover {
      background: linear-gradient(91deg, rgba(66, 149, 255, 0.80) 4.21%, rgba(7, 101, 241, 0.80) 84.5%);
    }
    &.disabled {
      background: #C3DAFC;
      cursor: not-allowed;
    }
  }
  &-btn__standard {
    background: linear-gradient(96deg, #924EF9 9.08%, #671BF8 92.76%);
    box-shadow: 0px 16px 36px 0px rgba(143, 80, 206, 0.14);
    color: #fff;
    &:hover {
      background: linear-gradient(96deg, rgba(146, 78, 249, 0.80) 9.08%, rgba(103, 27, 248, 0.80) 92.76%);
    }
    &.disabled {
      background: #E5D5FE;
      cursor: not-allowed;
    }
  }

}
</style>
